export const CREATE = 'TICKET/CREATE'
export const RESET = 'TICKET/RESET'
export const UPDATE_DECIMAL_PRECISIONS = 'TICKET/UPDATE_DECIMAL_PRECISIONS'
